import { render, staticRenderFns } from "./InsumosCrud.vue?vue&type=template&id=39346baf"
import script from "./InsumosCrud.vue?vue&type=script&lang=js"
export * from "./InsumosCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports